import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const RequestPayment = loadable(() => import(/* webpackChunkName: "RequestPayment" */ './RequestPayment'), {
  fallback: <LoadableFallback visible />,
});

const asyncRequestPayment = ({ route }) => (
  <RequestPayment route={route} />
);

asyncRequestPayment.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncRequestPayment;
